"use client";

import Footer from "@/app/component/FooterComponent";
import Footer2 from "@/app/component/FooterComponent/footer2";
import Header from "@/app/component/header";

import { useClientConfigProvider } from "@/app/config/client-config-provider";
import HeaderV2 from "@/app/versioning/components/v2/HeaderV2/HeaderV2";
import { right } from "@popperjs/core";
import {
  SessionStorageConstants,
  SessionStorageUtils,
} from "@thriwe-2-0/thriwe-ui-utils";
import { useEffect } from "react";

function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const { config } = useClientConfigProvider();
  /* const auth = !!SessionStorageUtils.getFromSessionStorage(
    SessionStorageConstants.AUTH_TOKEN
  ); */

  /*  return (
    <div>
      {!auth ? (
        <div
          className="pageHeader"
          style={{
            position: "fixed",
            width: "100%",
            zIndex: 10,
          }}
        >
          <Header floatMenuRight={true} />
        </div>
      ) : (
        <StaticPageHeader />
      )}

      <div className="static-page-main-container">{children}</div>
      <Footer />
    </div>
  ); */

  return (
    <>
      <div className="d-flex flex-column min-vh-100">
        <div
          className="pageHeader"
          style={{
            position: "fixed",
            width: "100%",
            zIndex: 10,
          }}
        >
          {config?.designVersion == "v1" ? <Header /> : <HeaderV2 />}
          {/* <Header /> */}
        </div>

        <div className="static-page-main-container">
          <div className="max-width-for-larger-devices">{children}</div>
        </div>

        <div>
          {config?.footer?.isShowCustomFooter ? <Footer2 /> : <Footer />}
        </div>
      </div>
    </>
  );
}

export default RootLayout;
